import React, { useRef } from 'react';
import { useEventListener } from 'usehooks-ts';
import { ENUM_CUS_EVENT } from '../enums/enums';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { IconX } from '@tabler/icons-react';
import { IconButton } from '@mui/material';

export default function Toaster() {
  const { t } = useTranslation();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const delayToastRef = useRef(false);

  useEventListener(ENUM_CUS_EVENT.translationToast, (e) => {
    const { message, type } = e.detail;

    if (delayToastRef.current) return;
    delayToastRef.current = true;

    enqueueSnackbar({
      variant: type,
      message: t(message),
      action: (snackbarId) => (
        <button
          className="toast-close-btn"
          aria-label={t('common.close')}
          style={{ background: 'transparent', border: 'none', padding: 0 }}
          onClick={() => closeSnackbar(snackbarId)}>
          <IconX size={20} />
        </button>
      )
    });

    setTimeout(() => (delayToastRef.current = false), 500);
  });

  return <></>;
}
